export const environment = {
  production: false,
  //url : "http://localhost:4200/dev/",
  //site: "http://localhost:4200/",
  url: "https://relord.arkia.nl/dev/",
  site: "https://relord.arkia.nl/",
  awslogin: "https://relord2020.auth.eu-central-1.amazoncognito.com/login?client_id=1618k6g5bb22q4svsf1ef1nafa&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://relord.arkia.nl/authenticated",
  aswlogout: "https://relord2020.auth.eu-central-1.amazoncognito.com/logout?client_id=1618k6g5bb22q4svsf1ef1nafa&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://relord.arkia.nl/authenticated",


};
